import CloseIcon from '../../../assets/icons/close.svg?react';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useAiModuleList } from '../../../hooks/queries/aiQueries';
import { useUpdateSetUp } from '../../../hooks/queries/setUpQueries';
import { useAuth } from '../../../hooks/useAuth';
import Pagination from '../../../components/Pagination/Pagination';
const SystemSetUpChargingDemandPredictionEditModal = ({ onClose, onSuccess }) => {
  const { user } = useAuth();
  const [isPending, setIsPending] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: aiModuleList, isLoading: isLoadingAiModuleList, error: errorAiModuleList } = useAiModuleList({
    AiModelType: 'ChargingDemandPrediction',
    Page: currentPage,
    PageSize: pageSize,
    OrderBy: 'CreatedDate',
    OrderDirection: 'desc',
  });
  const totalPages = Math.ceil(aiModuleList?.Total / pageSize);
  const [selectedAiModule, setSelectedAiModule] = useState(null);
  const updateSetUp = useUpdateSetUp();
  const handleUpdateSetUp = async () => {
    try {
      setIsPending(true);
      await updateSetUp.mutateAsync({
        group: 'ChargingDemandAi',
        key: 'CHARGING_DEMAND_AI_NAME',
        value: selectedAiModule.ModuleName,
        updatedBy: user.UserSysId,
      });
      await updateSetUp.mutateAsync({
        group: 'ChargingDemandAi',
        key: 'CHARGING_DEMAND_AI_VERSION',
        value: selectedAiModule.Version,
        updatedBy: user.UserSysId,
      });
      onSuccess();
    } catch (error) {
      console.error('일일 충전량 예측 모듈 수정 실패:', error);
      alert('일일 충전량 예측 모듈 수정에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  }
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>일일 충전량 예측 모듈 수정</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content mt-5">
          <div className='primary-table w-full'>
            <table>
              <thead>
                <tr>
                  <th width="40px"></th>
                  <th>모듈명</th>
                  <th>버전</th>
                  <th>Base 알고리즘</th>
                  <th>생성일시</th>
                </tr>
              </thead>
              <tbody>
                {aiModuleList?.Items?.map((aiModule) => (
                  <tr key={aiModule.AiModuleInfoSysId}>
                    <td>
                      <input type="checkbox" checked={selectedAiModule?.AiModuleInfoSysId === aiModule.AiModuleInfoSysId} onChange={() => setSelectedAiModule(aiModule)} />
                    </td>
                    <td>{aiModule.ModuleName}</td>
                    <td>{aiModule.Version}</td>
                    <td>{aiModule.OriginAiAlgorithm}</td>
                    <td>{dayjs(aiModule.CreatedDate).format('YYYY-MM-DD HH:mm:ss')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              size="small"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={onClose}>취소</button>
          <button className="btn big-btn btn-style-5" onClick={handleUpdateSetUp} disabled={isPending || !selectedAiModule}>{isPending ? '수정 중...' : '수정'}</button>
        </div>
      </div>
    </div>
  )
}

export default SystemSetUpChargingDemandPredictionEditModal;